export const absUrl = (url: string) => {
  return url;
};


export const buildUrl = (url: string, args, addSlash = false) => {
  let result = url;

  if (args) {
    const qs = new URLSearchParams(args).toString();
    if (qs.length !== 0) {
      result = `${result}?${qs}`;
    }
  }

  if (addSlash === true) result = `${result}/`;

  return result;
};

// temporarily defined messages
const tempMessages = {
  400: 'Bad Request',
  401: 'Unauthorized',
  402: 'Payment Required',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  407: 'Proxy Authentication Required',
  408: 'Request Timeout',
  409: 'Conflict',
  410: 'Gone',
  411: 'Length Required',
  412: 'Precondition Failed',
  413: 'Payload Too Large',
  414: 'URI Too Long',
  415: 'Unsupported Media Type',
  416: 'Requested Range Not Satisfiable',
  417: 'Expectation Failed',
  418: 'I\'m a teapot',

  500: 'Internal server error',
};

// Fetch helpers
const handleApiResponse = (r) => {
  return r.json()
    .catch(handleApiReject)
    .then((data: any) => {
      if (r.status == 200) {
        return data;
      } else {
        let errorMessage = tempMessages[r.status];
        if (!errorMessage) errorMessage = 'Noname error !!!';

        if (data.message) {
          errorMessage = data.message;
        }

        return Promise.reject({
          ...data,
          status: r.status,
          errorMessage: errorMessage,
        });
      }
    })
};

const handleApiReject = () => {
  return Promise.reject({
    errorMessage: 'A network error has occurred, please try again later',
  });
}

export const rawRequest = (method: string, url: string, token: string | null, data?: object) => {
  const headers = new Headers({
    'Content-Type': 'application/json',
  });

  if (token) {
    headers.set('Authorization', token);
  }

  const opts: any = {
    method,
    mode: 'cors',
    headers: headers,
  };

  if (typeof data != 'undefined') {
    opts.body = JSON.stringify(data);
  }

  return fetch(absUrl(url), opts)
};

export const apiRequest = (method: string, url: string, token: string | null, data?: object) => {
  return rawRequest(method, url, token, data).catch(handleApiReject).then(handleApiResponse);
};

export const apiGet = (url: string, token: string | null = null) => {
  return apiRequest('GET', url, token);
};

export const apiPost = (url: string, token: string | null = null, data: object = {}) => {
  return apiRequest("POST", url, token, data);
};

export const apiPut = (url: string, token: string | null = null, data: object = {}) => {
  return apiRequest("PUT", url, token, data);
};

export const apiDelete = (url: string, token: string | null = null) => {
  return apiRequest("DELETE", url, token);
};
